import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Panel, StatusBadge, ConfirmDelete } from "@/components/common";

const LABEL = { active: "Active", pending: "Pending Approval", rejected: "Rejected" };

export default function UsersPanel() {
  const [users, setUsers] = useState([]);
  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);
  const set = async (id, status) => { try { await api.post(`/users/${id}/status`, { status }); toast.success(status === "active" ? "Account approved" : "Account declined"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async (id) => { try { await api.delete(`/users/${id}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Panel title="User accounts & approvals" testid="users-panel">
      <p className="text-xs text-muted-foreground mb-3">New sign-ups are staff accounts. They can only use Duties, Own Vehicles and Market Owners (no finances, invoices or AI) after you approve them.</p>
      <div className="divide-y">{users.filter((u) => u.role !== "driver").map((u) => (
        <div key={u.id} className="py-3 flex flex-col sm:flex-row sm:items-center gap-2" data-testid={`user-row-${u.id}`}>
          <div className="min-w-0 flex-1"><div className="font-medium text-sm">{u.name} <span className="text-xs text-muted-foreground">· {u.role}</span></div><div className="text-xs text-muted-foreground break-all">{u.email}</div></div>
          {u.role !== "admin" ? (<>
            <StatusBadge value={LABEL[u.status || "active"]} testid={`user-status-${u.id}`} />
            <span className="text-xs text-muted-foreground">{u.status === "pending" ? "Waiting for approval" : ""}</span>
            <div className="flex gap-1">
              {u.status !== "active" && <Button size="sm" onClick={() => set(u.id, "active")} data-testid={`user-approve-${u.id}`}><Check className="h-4 w-4 mr-1" /> Approve</Button>}
              {u.status !== "rejected" && <Button size="sm" variant="outline" onClick={() => set(u.id, "rejected")} data-testid={`user-reject-${u.id}`}><X className="h-4 w-4 mr-1" /> {u.status === "active" ? "Revoke" : "Decline"}</Button>}
              <ConfirmDelete onConfirm={() => del(u.id)} trigger={<Button size="sm" variant="ghost" className="text-rose-600" data-testid={`user-delete-${u.id}`}><Trash2 className="h-4 w-4" /></Button>} />
            </div>
          </>) : <StatusBadge value="Active" />}
        </div>))}</div>
    </Panel>
  );
}
